
import * as React from 'react';
import Button from '../../Button';
import { Modal } from '../../Modal';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import './AgronomyReferenceSheetCreatorModal.css';
import { ITechReferenceSheet, ITechReferenceSheetType } from 'src/infrastructure/interfaces';
import { DropdownMenu } from 'src/components/DropdownMenu';
import { IDropdownMenuOption } from 'src/components/DropdownMenu/DropdownMenu';

export interface AgronomyReferenceSheetCreatorProps {
  show: any;
  onClose: any;
  onSubmit(agronomyReferenceSheetName: string,
            agronomyReferenceSheetType: ITechReferenceSheetType,
            formData: FormData,
            sheetToEdit: ITechReferenceSheet | undefined): void;
  sheetToEdit: ITechReferenceSheet | undefined;
}

export interface AgronomyReferenceSheetCreatorState {
  hasRequiredFields: boolean;
  agronomyReferenceSheetName: string;
  agronomyReferenceSheetType: ITechReferenceSheetType;
  imageFormData?: FormData;
  sheetToEdit: ITechReferenceSheet | undefined;
}

export default class AgronomyReferenceSheetCreatorModal extends React.Component<AgronomyReferenceSheetCreatorProps, AgronomyReferenceSheetCreatorState> {

  constructor(props: AgronomyReferenceSheetCreatorProps) {
    super(props);
    this.state = {
      imageFormData: undefined,
      agronomyReferenceSheetName: (props.sheetToEdit != undefined) ? props.sheetToEdit.title : '',
      agronomyReferenceSheetType: (props.sheetToEdit != undefined) ? props.sheetToEdit.sheet_category : ITechReferenceSheetType.AGRONOMY_SHEET,
      hasRequiredFields: false,
      sheetToEdit: props.sheetToEdit,
    };
  }

  componentDidUpdate(newProps: AgronomyReferenceSheetCreatorProps, prevState: AgronomyReferenceSheetCreatorState) {
    // Set title to title of selected sheet
    if ((newProps.sheetToEdit != undefined) && (newProps.sheetToEdit != prevState.sheetToEdit)) {
      this.setState({
        sheetToEdit: newProps.sheetToEdit,
        agronomyReferenceSheetName: newProps.sheetToEdit.title,
        agronomyReferenceSheetType: newProps.sheetToEdit.sheet_category,
      });
    }
  }

  validateInput() {
    const hasValidText = (this.state.agronomyReferenceSheetName.length > 1);
    const hasValidImages = (this.state.imageFormData != undefined) || (this.state.sheetToEdit != undefined);
    this.setState({
        hasRequiredFields: hasValidText && hasValidImages
    })
}

  closeModal() {
      this.setState({
          sheetToEdit: undefined,
          agronomyReferenceSheetName: '',
          agronomyReferenceSheetType: ITechReferenceSheetType.AGRONOMY_SHEET,
          imageFormData: undefined,
          hasRequiredFields: false,
      });
      this.props.onClose();
  }

  handleInputNameChange(newName: string) {
    this.setState({
        agronomyReferenceSheetName: newName
    }, () => this.validateInput());
  }

  handleChange(selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = new FormData();
          imageFormData.set(ImageFileTypes.AGRONOMY_REFERENCE_SHEET, selectorFiles[key]);
          this.setState({
              imageFormData
            }, () => this.validateInput());
          break;
        }
      }
    }
  }

  createTechSheetTypesList(): IDropdownMenuOption[] {

        var categoriesList: ITechReferenceSheetType[] = [ITechReferenceSheetType.AGRONOMY_SHEET,
                                                         ITechReferenceSheetType.SUSTAINABILITY_SHEET];
        var dropdownList: IDropdownMenuOption[] = [];
        dropdownList = dropdownList.concat(categoriesList.map((p) => {
            return {
                title: p,
                onClick: () => {
                    this.setState({
                        agronomyReferenceSheetType: p
                    });
                    this.validateInput();
                }
            }}))

        return dropdownList;
  }

  render() {
    const categoriesList = this.createTechSheetTypesList();

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                        {'Upload Tech/Reference Sheet'}
                    </h5>
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="agronomyReferenceSheetInputContainer">
                    <div className="agronomyReferenceSheetInputRow">
                        <b><label className="agronomyReferenceSheetInputLabel">Tech Sheet Name: </label></b>
                        <input
                            className="agronomyReferenceSheetInputTextView"
                            placeholder=""
                            maxLength={100}
                            value={this.state.agronomyReferenceSheetName}
                            onChange={e => {
                                this.handleInputNameChange(e.target.value);
                            } }/>
                    </div>
                    <div className="agronomyReferenceSheetInputRow">
                                <b><label>Tech Sheet Category: </label></b>
                                <div>
                                    <DropdownMenu
                                        title={this.state.agronomyReferenceSheetType}
                                        options={categoriesList}
                                        extraWide={true}
                                    />
                                </div>
                    </div>
                    <div className="agronomyReferenceSheetInputRow">
                        <label className="agronomyReferenceSheetInfoLabel">
                          <b>Image</b> (JPEG, 8.5"x11")
                        </label>
                        <input type="file" className="filepond" onChange={(e) => this.handleChange(e.target.files)} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                      if (this.state.hasRequiredFields) {
                        this.props.onSubmit(this.state.agronomyReferenceSheetName,
                                            this.state.agronomyReferenceSheetType,
                                           (this.state.imageFormData != null) ? this.state.imageFormData : new FormData(),
                                            this.state.sheetToEdit);
                        this.setState({
                          imageFormData: undefined,
                          agronomyReferenceSheetName: '',
                          agronomyReferenceSheetType: ITechReferenceSheetType.AGRONOMY_SHEET,
                          hasRequiredFields: false,
                          sheetToEdit: undefined,
                        })
                      }
                    }}
                >
                    {(this.state.sheetToEdit != undefined) ? "Save" : "Upload"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/AgronomyReferenceSheetCreatorModal/AgronomyReferenceSheetCreatorModal.tsx